import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router'
import { ApiService } from 'app/main/services/Api/api.service';
import { MediaService } from 'app/main/services/Media/media.service';
import { ToastService } from 'app/main/services/Toast/toast.service'
import { environment } from 'environments/environment';

@Component({
  selector: 'app-organizers-action',
  templateUrl: './organizers-action.component.html',
  styleUrls: ['./organizers-action.component.scss']
})
export class OrganizersActionComponent implements OnInit, OnDestroy {

  public contentHeader: object
  events: any
  addOrganizer: FormGroup
  addEventsToOrganizer: FormGroup
  // editOrganizer: FormGroup
  loading: boolean = false
  organizerID: any
  editMode: boolean = false
  organizedEvents: any
  organizedEventsLength: number = 0
  uploadedImagePath: string = ''
  isSaved: boolean = false
  previousUploadedImagePath: string = ''

  constructor(private router: Router,private api: ApiService,
    private mediaService: MediaService,
    private fb: FormBuilder,public toastService: ToastService,
    private url: ActivatedRoute) {
    // console.log(this.router.url)
    this.addOrganizer = this.fb.group({
      NameAr: ['',[Validators.required,this.arabicTextValidator]],
      NameEn: ['',[Validators.required,this.englishTextValidator]],
      Email: ['',[Validators.required,Validators.email]],
      PhoneNumber: ['',[Validators.required,this.numbersOnlyValidator]],
      Password: ['',[Validators.required,this.passwordValidator()]],
      // EventIds: [[],[Validators.required]],
      ProfilePictureFile: ['',[Validators.required]],
      Id:['']
    })

    this.addEventsToOrganizer = this.fb.group({
      eventId: [[],[Validators.required]],
      organizerId: ['',[Validators.required]]
    })
    // this.editOrganizer = this.fb.group({
    //   NameAr: ['',[Validators.required]],
    //   NameEn: ['',[Validators.required]],
    //   Email: ['',[Validators.required]],
    //   PhoneNumber: ['',[Validators.required]],
    //   ProfilePictureFile: ['',[Validators.required]],
    //   Id: ['',[Validators.required]],
    // })
  }

  ngOnInit(): void {
    this.setActiveMenu();
    this.loadEvents();
    this.setContentHeader();
    if(this.router.url.includes('edit-org')){
      this.editMode = true;
      const passwordControl = this.addOrganizer.get('Password');
      passwordControl?.clearValidators();
      passwordControl?.setValidators([this.passwordValidator()]);
      passwordControl?.updateValueAndValidity();
    }else{
      this.editMode = false
    }
  }
  private setActiveMenu(): void {
    if(this.router.url.includes('new-org') || this.router.url.includes('edit-org')){
      document.getElementById('المشرفين')?.classList.add('active')
    }else{
      document.getElementById('الرئيسية')?.classList.remove('active')
      document.getElementById('الفعاليات')?.classList.remove('active')
      document.getElementById('المستخدمين')?.classList.remove('active')
      document.getElementById('طلبات المشرفين')?.classList.remove('active')
      document.getElementById('فئات المناسبات')?.classList.remove('active')
      // document.getElementById('الإشعارات')?.classList.remove('active')
      document.getElementById('العروض')?.classList.remove('active')
      document.getElementById('المسئولين')?.classList.remove('active')
    }
  }
  private setContentHeader(): void {
    this.contentHeader = {
      headerTitle: this.router.url.includes('new-org') ? 'انشاء مشرف جديد' : 'تعديل المشرف',
      actionButton: false
    };
    if(this.router.url.includes('edit-org')){
      if(this.url.snapshot.params['id']){
        this.organizerID = this.url.snapshot.params['id'];
        this.loadOrganizerId(this.organizerID)
        this.loadEventsForOrganizer(this.organizerID)
      }
    } else {
      this.organizerID = this.generateGuid();
    }
  }
  private loadEvents(): void {
    this.api.showAllEvents(1, 100).subscribe({
      next: (res) => {
        this.events = res.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.message = 'حدث خطأ أثناء جلب الفعاليات';
      }
    });
  }

  organizer: any
  loadOrganizerId(id){
    this.api.showOrganizerByID(id).subscribe({
      next: (res) => {
        this.organizer = res.data;
        console.log(this.organizer)
        this.addOrganizer.patchValue({
          NameAr: this.organizer.nameAr,
          NameEn: this.organizer.nameEn,
          Email: this.organizer.email,
          PhoneNumber: this.organizer.phoneNumber,
          Password: this.organizer.password,
          // EventIds: this.organizer.eventIds,
          ProfilePictureFile: this.organizer.profilePicture
        })
        this.previewUrl1 = this.organizer.profilePicture;
        this.uploadedImagePath = this.organizer.profilePicture;
        this.previousUploadedImagePath = this.organizer.profilePicture;
      }, error: (error: HttpErrorResponse) => {}
    })
  }

  loadEventsForOrganizer(id){
    if(id){
      this.api.showEventOrganizer(id,1,100).subscribe({
        next: (response) => {
          this.organizedEvents = response.data.map( (item: any, index: number) => {
            return {
              indexNumber: index + 1,
              id: item.id,
              event: item.event
            }
          })
          this.organizedEventsLength = this.organizedEvents.length
          console.log(this.organizedEvents)
        }, error: (error: HttpErrorResponse) => {}
      })
    }
  }

  // deleteEventFromThisOrganizer(id: string) {
  //   if(id){
  //     this.api.deleteEventOrganizer(id).subscribe({
  //       next: (response) => {
  //         if(response.success == true){
  //           console.log(response)
  //           this.toastService.show('تم حذف الفعالية من المشرف بنجاح ✅');
  //           this.loadEventsForOrganizer(this.organizerID)
  //         }
  //       }, error: (error: HttpErrorResponse) => {
  //         this.toastService.show('حدث خطأ أثناء حذف الفعالية من المشرف ❌');
  //       }
  //     })
  //   }
  // }

  previewUrl1: string | ArrayBuffer | null = null;
  onFileSelected(event: Event,type: string): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        if (type === 'orgImage') {
          this.previewUrl1 = reader.result; // Set preview for first upload
        }
      };
      reader.readAsDataURL(file);

      // Auto upload to media api (EntityOwnerType.User = 1)
      this.mediaService.uploadMedia(file, this.organizerID, 1, 1).subscribe({
        next: (response) => {
          this.uploadedImagePath = response.filePath;
          this.addOrganizer.patchValue({
            ProfilePictureFile: response.filePath
          });
          this.toastService.show("تم رفع الصورة بنجاح");
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.show("حدث خطأ عند رفع الصورة");
        }
      });
    }
  }

  // Rows management
  count: number = 1;
  // rows: any[] = [];
  rows: {id: number, eventId?: any}[] = [];
  color: string = ''
  
  getPreviewUrl(): string {
    if (!this.previewUrl1) {
      return '';
    }
    const urlStr = this.previewUrl1.toString();
    if (urlStr.startsWith('data:image/') || urlStr.startsWith('http://') || urlStr.startsWith('https://')) {
      return urlStr;
    }
    try {
      const backendUrl = new URL(environment.apiUrl);
      const cleanPath = urlStr.startsWith('/') ? urlStr.substring(1) : urlStr;
      return `${backendUrl.protocol}//${backendUrl.host}/${cleanPath}`;
    } catch (e) {
      return urlStr;
    }
  }
  
  save(): void {
    this.addOrganizer.markAllAsTouched();
    const formValue = this.addOrganizer.value;
    if(this.router.url.includes('edit-org')){
      if(!this.organizerID || !formValue.NameAr || !formValue.NameEn || !formValue.Email || !formValue.PhoneNumber || !this.uploadedImagePath){
        this.toastService.message = 'الرجاء إكمال جميع الحقول المطلوبة';
        return;
      }
      this.loading = true;

      if(this.newArrayToAddEventsInEditMode){
        this.api.addEventsToOrganizer(this.newArrayToAddEventsInEditMode).subscribe({
          next: (response) => {
            console.log(response)
          },
          error: (error: HttpErrorResponse) => {
            this.color = 'c00d46'
            this.loading = false;
            this.toastService.message = error.error?.message || 'حدث خطأ أثناء تعديل المشرف';
          }
        })
      }
      const payload: any = {
        id: this.organizerID,
        nameAr: formValue.NameAr,
        nameEn: formValue.NameEn,
        email: formValue.Email,
        phoneNumber: formValue.PhoneNumber,
        profilePicture: this.uploadedImagePath
      };
      if (formValue.Password) {
        payload.password = formValue.Password;
      }

      this.api.updateOrganizer(payload).subscribe({
        next: (response) => {
          if(response.success == true){
            if (this.uploadedImagePath) {
              this.mediaService.keepMedia(this.uploadedImagePath).subscribe();
            }
            this.isSaved = true;
            this.color = '3F8260'
            this.loading = false;
            this.toastService.message = 'تم تعديل المشرف بنجاح';
            this.router.navigate(['/organizers']);
          }else{
            this.color = 'c00d46'
            this.loading = false;
            this.toastService.message = 'حدث خطأ أثناء تعديل المشرف';
          }
        },
        error: (error: HttpErrorResponse) => {
          this.color = 'c00d46'
          this.loading = false;
          this.toastService.message = error.error?.message || 'حدث خطأ أثناء تعديل المشرف';
        }
      });
    }else{
      console.log(this.addOrganizer)
      if (this.addOrganizer.invalid) {
        this.markFormGroupTouched(this.addOrganizer);
        this.toastService.message = 'الرجاء إكمال جميع الحقول المطلوبة';
        return;
      }
      this.loading = true;
      const payload = {
        id: this.organizerID,
        nameAr: formValue.NameAr,
        nameEn: formValue.NameEn,
        email: formValue.Email,
        phoneNumber: formValue.PhoneNumber,
        password: formValue.Password,
        profilePicture: this.uploadedImagePath || ''
      };
      this.api.addOrganizer(payload).subscribe({
        next: (response) => {
          if(response.success == true){
            if (this.uploadedImagePath) {
              this.mediaService.keepMedia(this.uploadedImagePath).subscribe();
            }
            this.isSaved = true;
            this.color = '3F8260'
            this.loading = false;
            this.toastService.message = 'تم إنشاء المشرف بنجاح';
            this.router.navigate(['/organizers']);
          }else{
            this.color = 'c00d46'
            this.loading = false;
            this.toastService.message = 'حدث خطأ أثناء إنشاء المشرف';
          }
        },
        error: (error: HttpErrorResponse) => {
          this.color = 'c00d46'
          this.loading = false;
          this.toastService.message = error.error?.message || 'حدث خطأ أثناء إنشاء المشرف';
        }
      });
    }
  }

  // Helper to mark all fields as touched
  private markFormGroupTouched(formGroup: FormGroup | FormArray): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markFormGroupTouched(control);
      }
    });
  }

  // Row management
  addRow(type: 'add' | 'remove', index?: number): void {
    if (type === 'add') {
      this.rows.push({ id: this.count++ });
    } else if (type === 'remove' && index !== undefined) {
      this.rows.splice(index, 1);
      this.updateEventIds();
    }
  }
  onEventSelect(eventId: any, rowIndex: number): void {
    console.log(eventId.id)
    this.rows[rowIndex].eventId = eventId.id;
    this.updateEventIds();
  }
  private updateEventIds(): void {
    const eventIds = this.rows
      .map(row => row.eventId)
      .filter(id => id !== undefined) as string[];
    
    this.addOrganizer.patchValue({
      EventIds: eventIds
    });
    // console.log(this.addOrganizer.value.EventIds);
  }

  newArrayToAddEventsInEditMode: any;
  addRow2(type: 'add' | 'remove', index?: number): void {
    if (type === 'add') {
      this.rows.push({ id: this.count++ });
    } else if (type === 'remove' && index !== undefined) {
      this.rows.splice(index, 1);
      this.updateEventIds2();
    }
  }
  onEventSelect2(eventId: any, rowIndex: number): void {
    console.log(eventId.id)
    this.rows[rowIndex].eventId = eventId.id;
    this.updateEventIds2();
  }
  private updateEventIds2(): void {
    const eventIds = this.rows
      .map((row) => {
        return{
          eventId: row.eventId,
          organizerId: this.organizerID
        }
      })
    this.newArrayToAddEventsInEditMode = eventIds
      // .filter(id => id !== undefined) as string[];
    console.log(this.newArrayToAddEventsInEditMode)
  }
  arabicTextValidator(control: AbstractControl) {
    if (!control.value) return null; // skip validation if empty
  
    const arabicRegex = /^[\u0600-\u06FF\s\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/;
    return arabicRegex.test(control.value) ? null : { arabicOnly: true };
  }
  englishTextValidator(control: AbstractControl) {
    if (!control.value) return null;
    const englishRegex = /^[A-Za-z\s]+$/;
    return englishRegex.test(control.value) ? null : { englishOnly: true };
  }
  numbersOnlyValidator(control: AbstractControl) {
    if (!control.value) return null;
    const numbersRegex = /^[0-9]+$/;
    return numbersRegex.test(control.value) ? null : { numbersOnly: true };
  }
  passwordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null; // skip validation if empty
      }

      const value = control.value;
      const errors: any = {};

      // 1. Minimum length 8 characters
      if (value.length < 8) {
        errors.minLength = { requiredLength: 8, actualLength: value.length };
      }

      // 2. At least 1 uppercase letter
      if (!/[A-Z]/.test(value)) {
        errors.missingUppercase = true;
      }

      // 3. At least 1 lowercase letter
      if (!/[a-z]/.test(value)) {
        errors.missingLowercase = true;
      }

      // 4. At least 1 number
      if (!/[0-9]/.test(value)) {
        errors.missingNumber = true;
      }

      // 5. At least 1 symbol (special character)
      if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value)) {
        errors.missingSymbol = true;
      }

      // Return null if no errors, otherwise return the errors object
      return Object.keys(errors).length ? { passwordRequirements: errors } : null;
    };
  }
  ngOnDestroy(): void {
    if (!this.isSaved) {
      if (this.uploadedImagePath && this.uploadedImagePath !== this.previousUploadedImagePath) {
        this.mediaService.deleteMedia(this.uploadedImagePath).subscribe();
      }
    }
  }

  generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

